import {
	handSize1,
	handSizeMinus3,
	handSizePlus2,
	noHandNextSeason,
	noWinterHand,
	polydactylism,
	// recharge1,
} from '@lc/const/modifiers';
import { playerHandSizeDefault } from '@lc/const/season';
import {
	summitDistributionDraft,
	summitDistributionSeasonStart,
} from '@lc/const/summit';
import {
	// decisionAwardResolution,
	// normalSeasonalTurn,
	summitResolution,
} from '@lc/const/turnTypes';
import { controller_card } from '@lc/controller/card';
import { controller_news } from '@lc/controller/news';
import { createGameState } from '@lc/interface/gameState/factory';
import { GameState } from '@lc/interface/gameState/types';
import { createPlayer } from '@lc/interface/player/factory';
import { Player } from '@lc/interface/player/types';
import {
	getCurrentSeasonDeck,
	shufflePlayerOrder,
	createDecks,
	getEnergyColorFromColor,
	createTurnOrderArray,
} from '@lc/lib/gamestate_helper';
import { getPlayerStateWithId } from '@lc/lib/player_helper';
import {
	getNextActivePlayer,
	incrementMonth,
	incrementSeason,
	resetMonthTracker,
	resetTurnTracker,
	updateModifiersSeason,
} from '@lc/lib/timeline/modifier';
import { timeline_resolution } from '@lc/lib/timeline/resolution';
import { timeline_resolution_winter } from '@lc/lib/timeline/resolution_winter';
import { timeline_summit } from '@lc/lib/timeline/summit';

class TimelineController {
	debugTesting = false;
	/**
	 *
	 * @param gameState
	 * @param playerId
	 */
	advance = async (
		gameState: GameState,
		playerId: number,
		ticker: string[]
	) => {
		const { monthTracker, seasonTracker } = gameState;

		console.log(
			'controller_timeline.advance called for player with id: ' +
				playerId +
				'. Active player is: ' +
				gameState.activePlayerId
		);

		// Stop advancement if other players are playing
		// on this turnType (should turnType be renamed to roundType??)
		if (gameState.isSummit === false && gameState.turnOrder.length > 0) {
			getNextActivePlayer(gameState);
			return;
		}

		if (monthTracker < 2) {
			// still months to progress in season // console.log('Month advanced')
			resetTurnTracker(gameState);
			incrementMonth(gameState);

			// console.log('gameState');
			// console.log(gameState);
			// console.log('ticker');
			// console.log(ticker);
			this.dealPlayersTwoCards(gameState);
			await controller_news.flipNews(gameState, ticker);
			await getNextActivePlayer(gameState);
			return;
		}

		// advance to summit resolution
		gameState.isSummit = true;
		gameState.turnType = summitResolution;
		await resetTurnTracker(gameState);

		let requestDecision = false;
		if (seasonTracker === 3) {
			gameState.isSummitWinter = true;
			// DELETE ON TURN SUMMIT CARDS HERE

			console.log('back here again');

			requestDecision =
				await timeline_resolution_winter.determineCurrentActivePlayerWinter(
					gameState,
					ticker
				);

			console.log('requestDecision');
			console.log(requestDecision);
			if (requestDecision) return;
		} else {
			requestDecision =
				await timeline_resolution.activeContractAwardResolution(
					gameState,
					ticker
				);
			if (requestDecision) return;
		}

		await timeline_summit.summit(
			gameState,
			gameState.isSummitWinter,
			ticker
		);

		if (gameState.isSummitWinter) {
			console.log('THE GAME IS OVER');
			// gameState.gameStatus = 2;
			return;
		}

		console.log('WE MADE IT TO THE NEXT SEASON!');
		await resetMonthTracker(gameState);
		await incrementSeason(gameState);
		this.dealPlayerHands(gameState);
		await updateModifiersSeason(gameState);
		gameState.isSummit = false;

		// NO NO BAD. Needs to be a decision turn type for summit cards & turn order
		// gameState.turnType = normalSeasonalTurn;
	};

	dealPlayerHands = (gameState: GameState) => {
		const currDeck = getCurrentSeasonDeck(gameState);

		for (let i = 0; i < gameState.playerStateArray.length; i++) {
			const playerHand: any = [];
			const player = gameState.playerStateArray[i];
			let handSize = playerHandSizeDefault;

			for (let e = 0; e < player.equipment.length; e++) {
				const currCard = controller_card.getCurrCard(
					player.equipment[e]
				) as any;
				if (currCard.modifier === polydactylism) {
					handSize++;
				}
			}

			if (player.modifiers.includes(handSizePlus2)) {
				handSize += 2;
			}

			if (player.modifiers.includes(handSizeMinus3)) {
				handSize -= 3;
			}

			if (player.modifiers.includes(handSize1)) {
				handSize = 1;
			}

			if (
				player.modifiers.includes(noWinterHand) ||
				player.modifiers.includes(noHandNextSeason)
			) {
				handSize = 0;
				continue; // redundant but skip to next player, deal no hand
			}

			for (let j = 1; j <= handSize; j++) {
				if (currDeck.length === 0) {
					break;
				}
				playerHand.push(currDeck.shift());
			}

			// TODO ONLY FOR TESTING SERVER REQUESTED ACTIONS
			// steal a battery from a neighbor (pop up server requested decision modal with image of card, request a neighbor)
			if (this.debugTesting) {
				playerHand.push(3);
				player.batteries++;
			}

			player.seasonalCards = playerHand;

			if (
				gameState.summitCardDistribution ===
				summitDistributionSeasonStart &&
				gameState.seasonTracker === 0
			) {
				if (
					gameState.DeckSummit.length > 0 &&
					gameState.DeckSummit[0] >= 0
				) {
					const currSummitCard =
						gameState.DeckSummit.shift() as number;
					player.summitCards.push(currSummitCard);
				}
			}
		}
	};


	dealPlayersTwoCards = (gameState: GameState) => {
		const currDeck = getCurrentSeasonDeck(gameState);

		for (let i = 0; i < gameState.playerStateArray.length; i++) {
			const player = gameState.playerStateArray[i];
			let handSize = 2;

			if ( // hmm todo skip the init or skip it all? 
				player.modifiers.includes(noWinterHand) ||
				player.modifiers.includes(noHandNextSeason)
			) {
				handSize = 0;
				continue; // redundant but skip to next player, deal no hand
			}

			if (currDeck.length > 0) {
				player.seasonalCards.push(currDeck.shift() || 0);
			}
			if (currDeck.length > 0) {
				player.seasonalCards.push(currDeck.shift() || 0);
			}
		}
	};


	initializeGame = (game_id_server: number, players: any[]) => {
		const playerStateArray: Player[] = [];
		const decks = createDecks();
		const turnOrder = createTurnOrderArray(players.length);
		shufflePlayerOrder(players, turnOrder);

		const gameState = createGameState(game_id_server, turnOrder, decks); // playerTableOrder TODO random start is not a priority, modifiers are way more important

		for (let i = 0; i < players.length; i++) {
			const color = players[i].color;
			const isBot =
				players[i].user_id === 1000001 ||
				players[i].user_id === 1000002 ||
				players[i].user_id === 1000003;

			const p = createPlayer(
				i,
				players[i].player_id,
				players[i].username,
				color,
				getEnergyColorFromColor(color),
				players[i].is_admin,
				isBot
			);

			if (gameState.summitCardDistribution === summitDistributionDraft) {
				const startingSummitCardId =
					gameState.DeckSummit.shift() as number;
				p.summitCards.push(startingSummitCardId);
			}

			playerStateArray.push(p);
		}

		playerStateArray.sort(
			(a: Player, b: Player) => a.playerId - b.playerId
		);

		gameState.playerStateArray = playerStateArray;
		this.dealPlayerHands(gameState);

		console.log('new game created');
		console.log('attempting to grab something from turnorder good sir');

		getNextActivePlayer(gameState);

		return gameState;
	};

	initializeSinglePlayerGame = (
		game_id_server: number,
		players: any[],
		isFall = false
	) => {
		const playerStateArray: Player[] = [];
		const decks = createDecks();
		const turnOrder = createTurnOrderArray(players.length); // ALWAYS BEGINS AT [0, 1, 2, 3?]
		shufflePlayerOrder(players, turnOrder);

		const gameState = createGameState(
			game_id_server,
			turnOrder,
			decks,
			true
		);

		if (isFall) {
			gameState.seasonTracker = 2;
		}

		for (let i = 0; i < players.length; i++) {
			const color = players[i].color;
			const isBot =
				players[i].user_id === 1000001 ||
				players[i].user_id === 1000002 ||
				players[i].user_id === 1000003;

			const p = createPlayer(
				i,
				players[i].player_id,
				players[i].username,
				color,
				getEnergyColorFromColor(color),
				players[i].is_admin,
				isBot
			);

			if (gameState.summitCardDistribution === summitDistributionDraft) {
				const startingSummitCardId =
					gameState.DeckSummit.shift() as number;
				p.summitCards.push(startingSummitCardId);
			}

			playerStateArray.push(p);

			if (isFall) {
				playerStateArray[i].factories = 4;
				playerStateArray[i].batteries = 2;
			}
		}

		playerStateArray.sort(
			(a: Player, b: Player) => a.playerId - b.playerId
		);

		console.log('creating player array');
		playerStateArray.sort(
			(a: Player, b: Player) => a.playerId - b.playerId
		);
		console.log(playerStateArray);

		gameState.playerStateArray = playerStateArray;
		this.dealPlayerHands(gameState);

		console.log('new SINGLE PLAYER game created');

		getNextActivePlayer(gameState);

		return gameState;
	};

	initializeTutorial = (game_id_server: number, players: any[]) => {
		const playerStateArray: Player[] = [];
		const decks = createDecks();
		const turnOrder = createTurnOrderArray(players.length); // ALWAYS BEGINS AT [0, 1, 2, 3?]
		// shufflePlayerOrder(players, turnOrder); silly for a tutorial

		const gameState = createGameState(
			game_id_server,
			turnOrder,
			decks,
			true,
			true
		);

		for (let i = 0; i < players.length; i++) {
			const color = players[i].color;
			const isBot =
				players[i].user_id === 1000001 ||
				players[i].user_id === 1000002 ||
				players[i].user_id === 1000003;

			const p = createPlayer(
				i,
				players[i].player_id,
				players[i].username,
				color,
				getEnergyColorFromColor(color),
				players[i].is_admin,
				isBot
			);

			if (gameState.summitCardDistribution === summitDistributionDraft) {
				const startingSummitCardId =
					gameState.DeckSummit.shift() as number;
				p.summitCards.push(startingSummitCardId);
			}

			playerStateArray.push(p);
		}

		playerStateArray.sort(
			(a: Player, b: Player) => a.playerId - b.playerId
		);

		console.log('creating player array');
		playerStateArray.sort(
			(a: Player, b: Player) => a.playerId - b.playerId
		);
		console.log(playerStateArray);

		gameState.playerStateArray = playerStateArray;
		this.dealPlayerHands(gameState);
		const pState = getPlayerStateWithId(gameState.playerStateArray, 0);
		pState.seasonalCards = [];
		pState.summitCards = [];
		pState.factoryEnergyArr = [];

		console.log('new SINGLE PLAYER game created');

		getNextActivePlayer(gameState);

		return gameState;
	};
}

export const controller_timeline = new TimelineController();
